// Dependency
import React from 'react';
import { useCart } from '../../../contexts/cart-context';

// Components
import CartItem from '../cart-item/cart-item';

// Styles
import * as styles from './cart-list.module.scss';

// Template
const CartList = ({ hasBorder }) => {
  const { cart } = useCart();
  return (
    <div className={
      `${styles.cartList}` +
      `${hasBorder === true ? ` ${styles.hasBorder}` : ''}`
    }>
      {cart && cart.selection && cart.selection.items && cart.selection.items.map( (item) => {
        return <CartItem key={item.line} item={item} />
      })}
    </div>
  );
};

export default CartList;